<template>
  <div>
    <div class="card flex flex-wrap p-4 lg:p-8">
      <vs-tabs>
        <vs-tab
          icon-pack="speakol"
          icon="speakol-fund-accounting"
          v-on:click.prevent="display('FUND')"
          label="Fund"
        ></vs-tab>
        <vs-tab
          icon-pack="speakol"
          icon="speakol-transaction"
          v-on:click.prevent="display('REFUND')"
          label="Refund"
        ></vs-tab>
      </vs-tabs>
      <div class="w-full mb-10 lg:mb-0 lg:w-2/3 lg:pr-8">
        <FundCard
          v-on:account-selected="handleAccountSelected"
          v-on:method-selected="handlePaymentMethodSelected"
          v-on:amount-change="handleAmountChange"
          v-on:fund="getTransactionLogs"
          v-if="fundTabSelected"
        ></FundCard>
        <RefundCard
          v-on:balance-change="handleBalanceChange"
          v-on:refund="getTransactionLogs"
          v-on:method-selected="handlePaymentMethodSelected"
          v-on:amount-change="handleAmountChange"
          v-on:account-selected="handleAccountSelected"
          v-if="!fundTabSelected"
        ></RefundCard>
      </div>
      <FundSummaryCard
        v-if="fundTabSelected"
        class="w-full lg:w-1/3"
        :amount="amount"
        :account="account"
        :paymentMethod="paymentMethod"
        isAdmin="true"
      >
      </FundSummaryCard>
      <RefundSummaryCard
        v-if="!fundTabSelected"
        class="w-full lg:w-1/3"
        :account="account"
        :refund="amount"
        :balance="balance"
        :maxAvailableVat="maxAvailableVat"
        :paymentMethod="paymentMethod"
        isAdmin="true"
      >
      </RefundSummaryCard>
    </div>
    <div class="card px-4 pt-8 mt-4 lg:p-8 lg:pb-10 lg:mt-10">
      <TransactionLog class="w-full" ref="transactionLog" />
    </div>
  </div>
</template>


<script>
import FundCard from './components/FundCard.vue'
import RefundCard from './components/RefundCard.vue'
import FundSummaryCard from './components/FundSummaryCard.vue'
import RefundSummaryCard from './components/RefundSummaryCard.vue'
import TransactionLog from './components/TransactionLog'
import {get} from 'lodash'

export default {
  components: {
    FundCard,
    RefundCard,
    FundSummaryCard,
    RefundSummaryCard,
    TransactionLog
  },

  data () {
    return {
      account: null,
      fundTabSelected: true,
      amount: null,
      balance: null,
      transactionLogs: {
        data: [],
        totalHits: 0
      },
      paymentMethod: null,
      maxAvailableVat: 0
    }
  },

  methods: {
    display (page = 'FUND') {
      this.fundTabSelected = page === 'FUND'
      this.amount = null
      this.balance = null
    },

    handleAmountChange (amount) {
      this.amount = amount
    },

    handleAccountSelected (account) {
      this.account = account
      this.balance = parseFloat(get(this.account, 'balance[0].balance', 0))
      this.maxAvailableVat = parseFloat(get(this.account, 'balance[0].vat', 0))
    },

    handlePaymentMethodSelected (paymentMethod) {
      this.paymentMethod = paymentMethod.value
    },

    handleBalanceChange (balance) {
      this.balance = balance
    },

    getTransactionLogs () {
      this.$refs.transactionLog.applyFilters()
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .total {
  font-weight: 500 !important;
  font-size: 14px !important;
}
.card {
  background: #fff;
}
</style>
